import React from "react";
import TotoHeadAndNeck from "./TotoHeadAndNeck";
import "./toto-occupant.css";

/**
 * TotoOccupant — the Rainbow companion's occupant of SONMI's PresenceVessel.
 *
 * A stylized Westie head that gently approaches the interior surface of the
 * vessel. The vessel is NOT part of this component — it is SONMI-owned and
 * wraps this occupant. If someone deletes the vessel and puts TotoOccupant
 * anywhere else, it should still read as Toto standing quietly in space.
 *
 * All Toto-specific artwork is confined to <TotoHeadAndNeck /> and this
 * wrapper. Shared platform code never imports either.
 */
export default function TotoOccupant() {
  return (
    <span data-testid="occupant-toto" style={{ display: "block", width: "100%" }}>
      <TotoHeadAndNeck />
    </span>
  );
}
